const isObject = (val) => val && typeof val === 'object' && !Array.isArray(val)

const deepEqual = (a, b) => {
  if (a === b) return true
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false
    for (let i = 0; i < a.length; i += 1) {
      if (!deepEqual(a[i], b[i])) return false
    }
    return true
  }
  if (isObject(a) && isObject(b)) {
    const aKeys = Object.keys(a)
    const bKeys = Object.keys(b)
    if (aKeys.length !== bKeys.length) return false
    for (let i = 0; i < aKeys.length; i += 1) {
      const key = aKeys[i]
      if (!deepEqual(a[key], b[key])) return false
    }
    return true
  }
  return false
}

export const getObjectChanges = (
  originalObject = {},
  object = {},
  ignore_fields = []
) => {
  if (!object || typeof object !== 'object') return {}

  const result = {}

  Object.keys(object).forEach((key) => {
    if (
      ignore_fields &&
      Array.isArray(ignore_fields) &&
      ignore_fields.includes(key)
    )
      return

    const newVal = object[key]
    const oldVal = originalObject ? originalObject[key] : undefined

    if (oldVal === undefined) {
      // field exists in object but not in original -> treat as changed
      result[key] = newVal
      return
    }

    if (isObject(newVal) && isObject(oldVal)) {
      const childChanged = getObjectChanges(oldVal, newVal, ignore_fields)
      if (Object.keys(childChanged).length) result[key] = childChanged
      return
    }

    if (Array.isArray(newVal) || Array.isArray(oldVal)) {
      if (!deepEqual(newVal, oldVal)) result[key] = newVal
      return
    }

    // primitive or other values
    if (!deepEqual(newVal, oldVal)) result[key] = newVal
  })

  return result
}

export default getObjectChanges
